/**
 * Redux action types for the loyalty program slice.
 */

export const FETCH_LOYALTY_PROGRAM_REQUEST = 'loyalty/program/FETCH_LOYALTY_PROGRAM_REQUEST';
export const FETCH_LOYALTY_PROGRAM_SUCCESS = 'loyalty/program/FETCH_LOYALTY_PROGRAM_SUCCESS';
export const FETCH_LOYALTY_PROGRAM_FAILURE = 'loyalty/program/FETCH_LOYALTY_PROGRAM_FAILURE';

export const CREATE_LOYALTY_PROGRAM_REQUEST = 'loyalty/program/CREATE_LOYALTY_PROGRAM_REQUEST';
export const CREATE_LOYALTY_PROGRAM_SUCCESS = 'loyalty/program/CREATE_LOYALTY_PROGRAM_SUCCESS';
export const CREATE_LOYALTY_PROGRAM_FAILURE = 'loyalty/program/CREATE_LOYALTY_PROGRAM_FAILURE';

export const UPDATE_LOYALTY_PROGRAM_REQUEST = 'loyalty/program/UPDATE_LOYALTY_PROGRAM_REQUEST';
export const UPDATE_LOYALTY_PROGRAM_SUCCESS = 'loyalty/program/UPDATE_LOYALTY_PROGRAM_SUCCESS';
export const UPDATE_LOYALTY_PROGRAM_FAILURE = 'loyalty/program/UPDATE_LOYALTY_PROGRAM_FAILURE';

export const UPDATE_LOYALTY_PROGRAM_STATUS_REQUEST =
  'loyalty/program/UPDATE_LOYALTY_PROGRAM_STATUS_REQUEST';
export const UPDATE_LOYALTY_PROGRAM_STATUS_SUCCESS =
  'loyalty/program/UPDATE_LOYALTY_PROGRAM_STATUS_SUCCESS';
export const UPDATE_LOYALTY_PROGRAM_STATUS_FAILURE =
  'loyalty/program/UPDATE_LOYALTY_PROGRAM_STATUS_FAILURE';

export const FETCH_LOYALTY_ACCRUAL_CONFIG_REQUEST =
  'loyalty/program/FETCH_LOYALTY_ACCRUAL_CONFIG_REQUEST';
export const FETCH_LOYALTY_ACCRUAL_CONFIG_SUCCESS =
  'loyalty/program/FETCH_LOYALTY_ACCRUAL_CONFIG_SUCCESS';
export const FETCH_LOYALTY_ACCRUAL_CONFIG_FAILURE =
  'loyalty/program/FETCH_LOYALTY_ACCRUAL_CONFIG_FAILURE';

export const UPDATE_LOYALTY_ACCRUAL_CONFIG_REQUEST =
  'loyalty/program/UPDATE_LOYALTY_ACCRUAL_CONFIG_REQUEST';
export const UPDATE_LOYALTY_ACCRUAL_CONFIG_SUCCESS =
  'loyalty/program/UPDATE_LOYALTY_ACCRUAL_CONFIG_SUCCESS';
export const UPDATE_LOYALTY_ACCRUAL_CONFIG_FAILURE =
  'loyalty/program/UPDATE_LOYALTY_ACCRUAL_CONFIG_FAILURE';

export const FETCH_LOYALTY_SPECIAL_REWARDS_REQUEST =
  'loyalty/program/FETCH_LOYALTY_SPECIAL_REWARDS_REQUEST';
export const FETCH_LOYALTY_SPECIAL_REWARDS_SUCCESS =
  'loyalty/program/FETCH_LOYALTY_SPECIAL_REWARDS_SUCCESS';
export const FETCH_LOYALTY_SPECIAL_REWARDS_FAILURE =
  'loyalty/program/FETCH_LOYALTY_SPECIAL_REWARDS_FAILURE';

export const UPDATE_LOYALTY_SPECIAL_REWARDS_REQUEST =
  'loyalty/program/UPDATE_LOYALTY_SPECIAL_REWARDS_REQUEST';
export const UPDATE_LOYALTY_SPECIAL_REWARDS_SUCCESS =
  'loyalty/program/UPDATE_LOYALTY_SPECIAL_REWARDS_SUCCESS';
export const UPDATE_LOYALTY_SPECIAL_REWARDS_FAILURE =
  'loyalty/program/UPDATE_LOYALTY_SPECIAL_REWARDS_FAILURE';

export const CLEAR_LOYALTY_PROGRAM_ERROR = 'loyalty/program/CLEAR_LOYALTY_PROGRAM_ERROR';

export const SET_SETUP_COMPLETE = 'loyalty/program/SET_SETUP_COMPLETE';

export const UPDATE_PROGRAM_LOCAL = 'loyalty/program/UPDATE_PROGRAM_LOCAL';
export const TOGGLE_PROGRAM_STATUS = 'loyalty/program/TOGGLE_PROGRAM_STATUS';
export const ADD_ITEM_RULE = 'loyalty/program/ADD_ITEM_RULE';
export const UPDATE_ITEM_RULE = 'loyalty/program/UPDATE_ITEM_RULE';
export const REMOVE_ITEM_RULE = 'loyalty/program/REMOVE_ITEM_RULE';
